<template>
    <div class="dokan-seller-badge-form-wrapper">
        <h1 class="wp-heading-inline">{{ pageTitle }}</h1>
        <div class="docs_and_videos">
            <a v-if="getDocURL()" :href="getDocURL()" target="_blank" class="docs_and_videos_title docs"><i class="fas fa-file-alt"></i> {{ __('Docs', 'dokan') }}</a>
            <a href="#" @click.prevent="toggleVideoPopup" class="docs_and_videos_title" v-if="getVideoID()">
                <i class="fas fa-play-circle"></i>{{ __('Videos', 'dokan') }}
            </a>
        </div>

        <transition name="fade">
            <VideoPopup @toggle="toggleVideoPopup" :videoId="getVideoID()" v-if="showVideoPopup"></VideoPopup>
        </transition>

        <hr class="wp-header-end">

        <form action="" method="post" id="post">
            <div id="poststuff">
                <div id="post-body" class="metabox-holder columns-2">
                    <div>
                        <div class="post-body-content postbox dokan-postbox badge__event-box" :class="checkRtl">
                            <div id="titlediv">
                                <BadgeEvents />
                                <div id="titlewrap">
                                    <h3>{{ this.__( 'Badge Name', 'dokan' ) }}</h3>
                                    <input type="text" v-model="badge.badge_name" name="post_title" size="30" id="title" autocomplete="off" :placeholder="__('e.g. Best Seller', 'dokan')" required="required" :disabled="!badge.event_type">
                                </div>
                            </div>
                            <div v-if="badge.event_type" class="badge-description">
                                <i class="info-icon"></i>
                                <p>{{ badge.event.description }}</p>
                            </div>
                        </div>

                        <div class="post-body-content badge__condition-box postbox dokan-postbox" :class="checkRtl">
                            <div id="postbox-container-2">
                                <div id="postdivrich" class="postarea wp-editor-expand">
                                    <div>
                                        <h3 class='mb-4 font-bold text-[1rem]'>{{ __('Condition & Level', 'dokan') }}</h3>
                                        <KeepAlive>
                                            <component
                                                :is="currentComponent"
                                                :event="badge.event"
                                                :key="badge.event.id ?? badge.event.id" />
                                        </KeepAlive>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div id="postbox-container-1" class="postbox-container postbox dokan-postbox">
                            <h1 class="badge_photo">{{ __('Badge Photo', 'dokan') }}</h1>
                            <template v-if="this.badge.event_type">
                                <p class='mb-3'> {{__('Click below image to edit or update badge image or ', 'dokan')}} <a href="#" @click.prevent="restoreDefaultImage()">{{ __( 'restore default.', 'dokan' ) }}</a></p>
                                <UploadImage
                                    :croppingWidth=60
                                    :croppingHeight=65
                                    :src="this.badge.badge_logo"
                                    @uploadedImage="uploadedImage"
                                    :showButton="false"/>
                                <p class='mt-3'>{{ __( 'Recommended image size 60X65 pixel, JPG, PNG or SVG.', 'dokan' ) }}</p>
                            </template>
                            <template v-else>
                                <p class='mb-3'>{{ __('Badge photo will be appeared here after selecting a badge event.', 'dokan') }}</p>
                                <img :src="this.badge.badge_logo" />
                            </template>
                        </div>

                        <div id="postbox-container-1" class="postbox-container postbox dokan-postbox postbox-status">
                            <div>
                                <h1>{{ __('Status', 'dokan') }}</h1>
                                <select style="min-width: 100%" v-model="badge.badge_status" name="badge_status" id="status" class="dokan-form-control">
                                    <option value="published">{{ __('Published', 'dokan') }}</option>
                                    <option value="draft">{{ __('Draft', 'dokan') }}</option>
                                </select>
                            </div>
                            <div class="pull-right margin-top-2x">
                                <button type="submit" class="button button-secondary button-large" @click.prevent="$router.push({name: 'SellerBadgeList'})">{{ __('Go Back', 'dokan') }}</button>
                                <button type="submit" class="button button-primary button-large" @click.prevent="saveBadgeData()" :disabled="disableAddNewButton()">{{ save_button }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <br class="clear">
            </div>
        </form>
        <LoaderModal v-if="loadSpinner" />
    </div>
</template>

<script>
const apiBase     = 'seller-badge';
const Postbox     = dokan_get_lib('Postbox');
const UploadImage = dokan_get_lib('UploadImage');

import BadgeEvents      from "../components/BadgeEvents.vue";
import DummyLevels      from "../components/BadgeLevels/DummyLevels.vue";
import LogicalComponent from '../components/BadgeLevels/LogicalComponent.vue';
import TrendingProduct  from '../components/BadgeLevels/TrendingProduct.vue';
import VerifiedSeller   from '../components/BadgeLevels/VerifiedSeller.vue';
import NoLevels         from "../components/BadgeLevels/NoLevels.vue";
import LoaderModal      from "../../components/LoaderModal.vue";
import defaultBadgeData from "../../BadgeSingle.json";
import mixin            from "../../Mixin.js";
import VideoPopup       from '../../../../../../src/admin/components/Modules/VideoPopup.vue';

import editBadgeIcon        from '../../../images/popup/update-badge.svg';
import editBadgeSuccessIcon from '../../../images/popup/badge-success.svg';
import defaultBadgeLogo     from '../../../images/popup/default-badge.svg';

export default {
    name: 'NewSellerBadge',
    mixins: [mixin],
    components: {
        BadgeEvents,
        DummyLevels,
        LogicalComponent,
        NoLevels,
        Postbox,
        TrendingProduct,
        UploadImage,
        VerifiedSeller,
        LoaderModal,
        VideoPopup,
        defaultBadgeData,
        editBadgeIcon,
        editBadgeSuccessIcon,
        defaultBadgeLogo,
    },
    data () {
        return {
            resetButton: false,
            originalLogo: '',
            save_button: this.__('Create', 'dokan'),
            loadSpinner: false,
            pageTitle: this.__('Creating New badge', 'dokan'),
            default_badge_icon: defaultBadgeLogo,
            badge: Object.assign( {}, this.getdefaultBadgeData() ),
            currentComponent: 'DummyLevels',
            showVideoPopup: false,
            responsibleComponents: {
                product_published: 'LogicalComponent',
                sale_amount: 'LogicalComponent',
                customer_review: 'LogicalComponent',
                number_of_items_sold: 'LogicalComponent',
                number_of_orders: 'LogicalComponent',
                store_support_count: 'LogicalComponent',
                trending_product: 'TrendingProduct',
                verified_seller: 'VerifiedSeller',
            },
        }
    },

    provide() {
        // use function syntax so that we can access `this`
        return {
            getSelectedBadge: this.getSelectedBadge,
            getBadgeEvent:    this.getBadgeEvent,
            setBadgeEvent:    this.setBadgeEvent,
            getBadgeLevels:   this.getBadgeLevels,
            setBadgeLevels:   this.setBadgeLevels,
        }
    },

    methods: {
        // provide method
        getSelectedBadge() {
            return this.badge;
        },

        /**
         * provide method: get selected badge event
         *
         * @returns defaultBadgeData.event
         */
        getBadgeEvent() {
            return this.badge.event;
        },

        // provide method
        setBadgeEvent( badge_event, badge_data = {} ) {
            this.badge.event = badge_event;

            // set badge data
            this.badge.badge_name = badge_data.badge_name ?? badge_event.title;
            this.badge.badge_logo = badge_data.badge_logo ?? badge_event.badge_logo;
            this.badge.badge_logo_raw = badge_data.badge_logo_raw ?? badge_event.badge_logo_raw;
            this.badge.event_type = badge_event.id;

            this.currentComponent = undefined === this.responsibleComponents[ badge_event.id ] ? 'NoLevels' : this.responsibleComponents[ badge_event.id ];
        },

        // provide method
        getBadgeLevels() {
            return this.badge.levels;
        },

        // provide method
        setBadgeLevels( badge_levels ) {
            if ( ! Array.isArray( badge_levels ) || ! badge_levels.length ) {
                this.badge.levels = [];
            } else {
                this.badge.levels = badge_levels;
            }
        },

        getdefaultBadgeData() {
            defaultBadgeData.badge_logo = defaultBadgeLogo;
            return defaultBadgeData;
        },

        fetchABadge (badge_id) {
            const self = this;
            self.loadSpinner = true
            dokan.api.get(`/seller-badge/${badge_id}`)
            .done( (response) => {
                self.badge = response;
                self.setBadgeEvent( self.badge.event, response );
            }).always( () => {
                self.loadSpinner = false;
            } ).fail( ( jqXHR ) => {
                self.badge = defaultBadgeData;
                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
            } );
        },

        saveBadgeData() {
            if ( this.badge.id ) {
                this.updateBadge();
            } else {
                // create new badge
                this.createBadge();
            }
        },

        createBadge () {
            let self = this;
            // validate badge name
            if ( ! self.badge.badge_name ) {
                self.showErrorAlert( self.__( 'Please enter a valid badge name.', 'dokan' ) );
                return;
            }

            // validate event tyoe
            if ( ! self.badge.event_type ) {
                self.showErrorAlert( self.__( 'Please select a valid badge event.', 'dokan' ) );
                return;
            }

            self.loadSpinner = true;
            dokan.api.post('/seller-badge/', self.badge)
            .done( ( response ) => {
                self.getSwal().fire({
                    imageUrl: editBadgeSuccessIcon,
                    title: self.__( 'Badge Added Successfully.', 'dokan' ),
                });
                self.$router.push({
                    name: 'SellerBadgeList',
                });
            }).always( () => {
                self.loadSpinner = false;
            }).fail( ( jqXHR ) => {
                self.badges = {};
                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
            });
        },

        updateBadge() {
            const self = this;
            //self.loadSpinner = true

            let swal_options = {
                title: this.__( 'Update Badge', 'dokan' ),
                text: this.__( 'Are you sure you want to update badge data? Note that, this action will update all existing vendor badges.', 'dokan' ),
                imageUrl: editBadgeIcon,
                width: 600,
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonText: this.__( 'No, Cancel', 'dokan' ),
                confirmButtonText: this.__( 'Yes, Update', 'dokan' ),
                confirmButtonColor: '#1A9ED4',
                showLoaderOnConfirm: true,
            };

            this.getSwal().fire( {
                ...swal_options,
                preConfirm: () => {
                    return dokan.api.put('/seller-badge/' + this.badge.id, this.badge)
                        .done( ( response ) => {
                            return response;
                        }).always( () => {
                        self.loadSpinner = false;
                    }).catch( (jqXHR) => {
                            let message = dokan_handle_ajax_error( jqXHR );
                            if ( message ) {
                                self.showErrorAlert( message );
                            }
                            return false;
                    });
                },
                allowOutsideClick: () => !this.getSwal().isLoading(),
                backdrop: true,
            } ).then( ( result ) => {
                // show success message
                if (result.isConfirmed) {
                    self.getSwal().fire({
                        imageUrl: editBadgeSuccessIcon,
                        title: self.__( 'Badge Updated Successfully.', 'dokan' ),
                    });
                    self.$router.push({
                        name: 'SellerBadgeList',
                    });
                } else {
                    this.loadSpinner = false;
                }
            });
        },

        uploadedImage (image) {
            this.badge.badge_logo = image.src;
            this.badge.badge_logo_raw = image.id;
        },

        restoreDefaultImage() {
            this.badge.badge_logo = this.badge.default_logo;
            this.badge.badge_logo_raw = this.badge.default_logo;
            this.$root.$emit('resetDokanUploadImage', {src: this.badge.formatted_default_logo});
        },

        disableAddNewButton() {
            if ( this.loadSpinner ) {
                return true;
            }
            return !(this.badge.badge_name && this.badge.event_type);

        },

        toggleVideoPopup() {
            this.showVideoPopup = ! this.showVideoPopup;
        },

        getDocURL() {
            return 'https://dokan.co/docs/wordpress/modules/seller-badge/';
        },

        getVideoID() {
            return '';
        }
    },
    computed: {
        checkRtl () {
            return isRtl === 1 && isRtl !== undefined ? 'lang_rtl' : ''
        },
    },
    created () {
        defaultBadgeData.badge_logo = this.default_badge_icon;
        if (this.$route.params.id) {
            this.pageTitle = this.__('Editing Badge', 'dokan');
            this.save_button = this.__('Update', 'dokan');
            this.fetchABadge(this.$route.params.id);
        }
    },
    mounted() {

    }
}
</script>

<style lang="less" scoped>
.dokan-seller-badge-form-wrapper {
    .docs_and_videos {
        display: flex;
        gap: 20px;

        a {
            color: #788383;
            font-size: 0.8125rem;
            display: flex;
            align-items: center;
            gap: 7px;
            text-decoration: none;
        }
    }

    h1.badge_photo {
        display: block !important;
    }

    #post-body {
        display: grid;
        grid-template-columns: 1fr 346px;
        column-gap: 20px;
        width: 100%;

        @media (max-width: 776px) {
            grid-template-columns: 1fr;
        }

        .postbox {
            border: 1px solid #E2E2E2;
            padding: 25px;
            width: 100% !important;
        }

        > div:nth-child(2) {
            display: grid;
            height: fit-content;
        }

        div.badge-description {
            .info-icon {
                background: url('../../../images/others/info.svg') no-repeat center;
                width: 17px;
                height: 17px;
                line-height: 17px;
                display: inline-block;
                vertical-align: middle;
            }
            p {
                display: inline-block;
                margin-left: 6px;
                font-weight: 400;
                font-size: 0.75rem;
                line-height: 17px;
                vertical-align: middle;
                color: #575D64;
            }
        }
    }

    #titlediv {
        display: flex;
        flex-flow: row wrap;
        gap: 20px;

        @media (max-width: 767px) {
            flex-direction: column;
        }

        > div {
            flex: 1;

            @media (max-width: 767px) {
                width: 100%;
            }
        }

        h3 {
            margin: 0 0 0.625em;
        }
    }

    #title,
    #status {
        border: 1px solid #E2E2E2;
        border-radius: 3px;
        height: 42px !important;
        font-size: 15px !important;
    }

    #titlediv h3,
    .postbox-status h1,
    .badge_photo {
        font-size: 1rem;
        font-weight: 700;
        padding: 0;
        margin: 0 0 0.625em;
    }

    .badge_photo + p {
        margin-top: 0;
    }

    .pull-right {
        display: flex;
        justify-content: end;
        gap: 10px;
        margin-top: 20px;
    }
}
.lang_rtl {
    float: right !important;
}
</style>
<style lang="less">
.dokan-seller-badge-form-wrapper {
    font-family: "SF Pro Text", sans-serif;

    * {
        box-sizing: border-box;
    }

    .input-group {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: stretch;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        &:not(.has-validation) > :not(:last-child) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .input-group-text {
            display: flex;
            align-items: center;
            padding: .375rem .75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #212529;
            text-align: center;
            white-space: nowrap;
            background-color: #f5f5f5;
            border: 1px solid #e2e2e2;
            border-radius: .375rem;
        }

        &> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
            margin-left: calc(1px * -1);
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }

        .form-control {
            display: block;
            padding: .375rem .75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #424242;
            background-color: #ffffff;
            background-clip: padding-box;
            border: 1px solid #e2e2e2;
            appearance: none;
            border-radius: 0.375rem;
            transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        }

        button, input, optgroup, select, textarea {
            margin: 0;
            font-family: inherit;
            font-size: inherit;
            line-height: inherit;
        }

        .icon {
            width: 17px;
            height: 17px;
            line-height: 17px;
            display: inline-block;
            vertical-align: middle;
        }

        .icon-compare {
            background: url('../../../images/input-group-icons/compare.svg') no-repeat center;
        }
        .icon-count {
            background: url('../../../images/input-group-icons/count.svg') no-repeat center;
        }
        .icon-order {
            background: url('../../../images/input-group-icons/order.svg') no-repeat center;
        }
        .icon-price {
            background: url('../../../images/input-group-icons/price.svg') no-repeat center;
        }
        .icon-review {
            background: url('../../../images/input-group-icons/review.svg') no-repeat center;
        }
        .icon-timing {
            background: url('../../../images/input-group-icons/timing.svg') no-repeat center;
        }
        .icon-trending {
            background: url('../../../images/input-group-icons/trending.svg') no-repeat center;
        }
        .icon-document {
            background: url('../../../images/input-group-icons/document.svg') no-repeat center;
        }
        .icon-support {
            background: url('../../../images/input-group-icons/support.svg') no-repeat center;
        }
    }
}
</style>
